var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pageWithHeaderBody userBackground layout-column" },
    [
      _c(
        "div",
        { class: _vm.$style.accountProfileContainer },
        [
          _c(
            "div",
            { class: _vm.$style.accountProfileNavigation },
            [
              _c("image-editor", { attrs: { "is-admin": _vm.isAdmin } }),
              _c("navigation"),
            ],
            1
          ),
          _vm.activeModuleComponent
            ? _c(_vm.activeModuleComponent, {
                tag: "component",
                class: _vm.$style.accountProfileContent,
                attrs: {
                  state: _vm.state,
                  "user-account": _vm.userAccount,
                  "is-admin": _vm.isAdmin,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }